import dayjs, { Dayjs } from 'dayjs'

const timeFormat = (date: string) => {
  return date.substr(0, 2) + ':' + date.substr(2, 2) + ':' + date.substr(4, 2)
}

const dateFormat = (date: Dayjs | Date | string) => {
  if (date) {
    return dayjs(date).format('DD/MM/YYYY')
  }

  return null
}

export const dateAndTimeFormat = (
  date: Dayjs | Date | string,
  time: string
) => {
  let dateTime = ''
  if (date) {
    dateTime += dateFormat(date)
  }
  if (time && time.length === 6) {
    dateTime += ' ' + timeFormat(time)
  }

  return dateTime.length ? dateTime : undefined
}
